import {Construtor} from './construtor';
import { Usuario } from './usuario';

export class UsuarioArea implements Construtor<UsuarioArea> {

  public idUsuarioArea: number;
  public usuario: Usuario;
  public idAreaCliente: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
      this.usuario = new Usuario();
    if (object !== undefined) {
      if (object instanceof UsuarioArea) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }
      if (!this.modeloCompleto()) {
        return null;
      }
    }
    return this;
  }

  copyObject(usuarioArea: UsuarioArea): void {
    this.idUsuarioArea = usuarioArea.idUsuarioArea;
    this.usuario = usuarioArea.usuario;
    this.idAreaCliente = usuarioArea.idAreaCliente;
  }

  parseFromJson(usuarioArea: any): void {
    this.idUsuarioArea = usuarioArea.idUsuarioArea;
    this.usuario = usuarioArea.usuario;
    this.idAreaCliente = usuarioArea.idAreaCliente;
  }

  modeloCompleto(): boolean {
    return this.idAreaCliente !== undefined && this.usuario !== undefined;
  }

  getNewInstance(object?: any): UsuarioArea {
    return new UsuarioArea(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/usuario-area.ts